<template>
  <v-dialog v-model="modalOpen" max-width="400px" class="WorkflowModal">
    <v-card outlined>
      <v-card-title class="WorkflowModal__title">
        <v-row>
          <v-col cols="auto" class="mr-auto"> Workflow Update </v-col>
          <v-col cols="auto">
            <v-btn icon @click="close">
              <v-icon small> mdi-close </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="WorkflowModal__content">
        <p>
          This credential cannot be deleted because it being used by the
          following workflows. Update the workflows before deleting the
          credential.
        </p>
        <v-list-item-title v-for="item in workflows" :key="item.id">
          - {{ item.name }}
        </v-list-item-title>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: credentialsGetters, mapMutations: credentialsMutation } =
  createNamespacedHelpers('credentials');

export default {
  name: 'WorkflowModal',
  data() {
    return {
      modalOpen: false,
    };
  },
  watch: {
    workflows(newVal) {
      if (newVal.length > 0) {
        this.open();
      }
    },
  },
  computed: {
    ...credentialsGetters({
      workflows: 'WORKFLOWS_USING_CREDENTIAL_TO_BE_DELETED',
    }),
  },
  methods: {
    ...credentialsMutation({
      setWorkflowsUsingCredentials: 'SET_WORKFLOWS_USING_CREDENTIALS',
    }),
    open() {
      this.modalOpen = true;
    },
    close() {
      this.setWorkflowsUsingCredentials([]);
      this.modalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './workflow-modal';
</style>
